import { render, staticRenderFns } from "./data-table-personal-transactions.vue?vue&type=template&id=76dc9807&scoped=true&"
import script from "./data-table-personal-transactions.vue?vue&type=script&lang=js&"
export * from "./data-table-personal-transactions.vue?vue&type=script&lang=js&"
import style0 from "./data-table-personal-transactions.vue?vue&type=style&index=0&id=76dc9807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dc9807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76dc9807')) {
      api.createRecord('76dc9807', component.options)
    } else {
      api.reload('76dc9807', component.options)
    }
    module.hot.accept("./data-table-personal-transactions.vue?vue&type=template&id=76dc9807&scoped=true&", function () {
      api.rerender('76dc9807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/sidesheet-additions/data-table-personal-transactions.vue"
export default component.exports